export default __webpack_public_path__ + "static/media/QSM3Exp.abb6cec5.md";